import React, { Fragment, useState, useEffect, useRef } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link } from "react-router-dom";
import { Button, Dropdown, Pagination } from "react-bootstrap";
import { db, functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";
import Toast from "../toast/SetToast";
import { notifyError, notifyTopRight } from "../toast/SetToast";
import { useAuth } from "../../../context/AuthContext";
/// images
import avartar5 from "../../../images/avatar/5.png";
import avartar1 from "../../../images/avatar/1.png";
import greenMark from "../../../images/avatar/green-check-mark.png";
import redMark from "../../../images/avatar/red-x.png";
import yellowMark from "../../../images/avatar/exclamation-mark.png";

import {
  query,
  endAt,
  getDocs,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  doc,
  deleteDoc,
  updateDoc,
  getDoc,
  where,
} from "firebase/firestore";
import swal from "sweetalert";
import { colors } from "@material-ui/core";
import {
  filterRecordsByStaffCustomerAccess,
  hasExplicitStaffCustomerAccess,
  isStaffCustomerScopedUser,
} from "../../../utils/staffCustomerAccess";

const PatientTextInputForm = ({
  title = "Test",
  htmlFor = "",
  id = "",
  name = "",
  placeholder = "",
  refvalue,
  type = "text",
  value,
  onChange,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-lg-4 col-form-label"
        style={{ color: "#424242" }}
        htmlFor={htmlFor}
      >
        {title}
        <span className="text-danger">*</span>
      </label>
      <div className="col-lg-6">
        <input
          type={type}
          className="form-control"
          id={id}
          name={name}
          placeholder={placeholder}
          required
          ref={refvalue}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

const PatientTextInputNotRequiredForm = ({
  title = "Test",
  htmlFor = "",
  id = "",
  name = "",
  placeholder = "",
  refvalue,
  type = "text",
  defaultValue = "",
  description,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-lg-4 col-form-label"
        style={{ color: "#424242" }}
        htmlFor={htmlFor}
      >
        {title}
      </label>
      <div className="col-lg-6">
        <input
          type={type}
          className="form-control"
          id={id}
          name={name}
          placeholder={placeholder}
          ref={refvalue}
          defaultValue={defaultValue}
        />
        <small>{description}</small>
      </div>
    </div>
  );
};
const PatientDropDownForm = ({
  title = "",
  htmlFor = "",
  id = "",
  name = "",
  refvalue,
  placeholder = "Please select",
  options = [""],
  defaultValue = "",
  onChange,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-lg-4 col-form-label"
        style={{ color: "#424242" }}
        htmlFor={htmlFor}
      >
        {title}
        <span className="text-danger"></span>
      </label>
      <div className="col-lg-6">
        <select
          className="form-control"
          id={id}
          name={name}
          ref={refvalue}
          defaultValue={defaultValue}
          onChange={onChange}
        >
          <option value="">{placeholder}</option>
          {options.map((value) => (
            <option value={value}>{value}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

const PatientDropDownFormRequired = ({
  title = "",
  htmlFor = "",
  id = "",
  name = "",
  refvalue,
  placeholder = "Please select",
  options = [""],
  defaultValue = "",
  onChange,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-lg-4 col-form-label"
        style={{ color: "#424242" }}
        htmlFor={htmlFor}
      >
        {title}
        <span className="text-danger"></span>
      </label>
      <div className="col-lg-6">
        <select
          className="form-control"
          id={id}
          name={name}
          ref={refvalue}
          defaultValue={defaultValue}
          onChange={onChange}
          required
        >
          <option value="">{placeholder}</option>
          {options.map((value) => (
            <option value={value}>{value}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

const PatientDateOfBirthDropdown = ({ title = "วันเดือนปีเกิด", refvalue, defaultValue = "" }) => {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [yearFormat, setYearFormat] = useState("BE"); // BE or CE
  const [displayDate, setDisplayDate] = useState("");
  const internalRef = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  // Generate year options based on format
  const generateYears = () => {
    const years = [];
    if (yearFormat === "BE") {
      // B.E. years: 2443-2568 (1900-2025 C.E.)
      for (let i = 2568; i >= 2443; i--) {
        years.push(i);
      }
    } else {
      // C.E. years: 1900-2025
      for (let i = 2025; i >= 1900; i--) {
        years.push(i);
      }
    }
    return years;
  };

  // Initialize from defaultValue (ISO date format: YYYY-MM-DD)
  useEffect(() => {
    if (defaultValue && !isInitialized) {
      const dateMatch = defaultValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (dateMatch) {
        const [, ceYear, monthStr, dayStr] = dateMatch;
        const ceYearNum = parseInt(ceYear, 10);
        const beYearNum = ceYearNum + 543;

        setDay(parseInt(dayStr, 10).toString());
        setMonth(parseInt(monthStr, 10).toString());
        // Default to B.E. format and convert the year
        setYear(beYearNum.toString());
        setYearFormat("BE");
        setIsInitialized(true);
      }
    }
  }, [defaultValue, isInitialized]);

  // Detect touch device
  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  // Convert to ISO date format (C.E.)
  useEffect(() => {
    if (day && month && year) {
      // Convert B.E. to C.E. if needed
      const ceYear =
        yearFormat === "BE" ? parseInt(year) - 543 : parseInt(year);
      const monthNum = String(month).padStart(2, "0");
      const dayNum = String(day).padStart(2, "0");

      // Validate date
      const dateObj = new Date(ceYear, parseInt(month) - 1, parseInt(day));
      const isValidDate =
        dateObj.getFullYear() === ceYear &&
        dateObj.getMonth() === parseInt(month) - 1 &&
        dateObj.getDate() === parseInt(day);

      if (isValidDate) {
        const isoDate = `${ceYear}-${monthNum}-${dayNum}`;

        // Update ref value for form submission
        if (internalRef.current) {
          internalRef.current.value = isoDate;
        }

        // Create display text showing both formats
        const beYear = ceYear + 543;
        const displayText = `${dayNum}/${monthNum}/${ceYear} (ค.ศ.) = ${dayNum}/${monthNum}/${beYear} (พ.ศ.)`;
        setDisplayDate(displayText);
      } else {
        setDisplayDate("วันที่ไม่ถูกต้อง");
        if (internalRef.current) {
          internalRef.current.value = "";
        }
      }
    } else {
      setDisplayDate("");
      if (internalRef.current) {
        internalRef.current.value = "";
      }
    }
  }, [day, month, year, yearFormat]);

  return (
    <div className="form-group row">
      <label className="col-lg-4 col-form-label" style={{ color: "#424242" }}>
        {title}
      </label>
      <div className="col-lg-6">
        {/* Year format toggle */}
        <div className="mb-2">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="yearFormat"
              id="yearFormatBE"
              value="BE"
              checked={yearFormat === "BE"}
              onChange={(e) => {
                // Convert year from C.E. to B.E. if year exists
                if (year && yearFormat === "CE") {
                  const ceYear = parseInt(year, 10);
                  const beYear = ceYear + 543;
                  setYear(beYear.toString());
                }
                setYearFormat(e.target.value);
              }}
            />
            <label className="form-check-label" htmlFor="yearFormatBE">
              พ.ศ.
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="yearFormat"
              id="yearFormatCE"
              value="CE"
              checked={yearFormat === "CE"}
              onChange={(e) => {
                // Convert year from B.E. to C.E. if year exists
                if (year && yearFormat === "BE") {
                  const beYear = parseInt(year, 10);
                  const ceYear = beYear - 543;
                  setYear(ceYear.toString());
                }
                setYearFormat(e.target.value);
              }}
            />
            <label className="form-check-label" htmlFor="yearFormatCE">
              ค.ศ.
            </label>
          </div>
        </div>

        {/* Date dropdowns */}
        <div className="d-flex" style={{ gap: "8px" }}>
          {/* Day */}
          <select
            className="form-control"
            value={day}
            onChange={(e) => setDay(e.target.value)}
            style={{ flex: 1 }}
          >
            <option value="">วัน</option>
            {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>

          {/* Month */}
          <select
            className="form-control"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            style={{ flex: 1.5 }}
          >
            <option value="">เดือน</option>
            {thaiMonths.map((m, idx) => (
              <option key={idx + 1} value={idx + 1}>
                {m}
              </option>
            ))}
          </select>

          {/* Year */}
          <div style={{ flex: 1.5 }}>
            {isTouchDevice ? (
              // Mobile/Tablet: Use select dropdown
              <select
                className="form-control"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                <option value="">ปี</option>
                {generateYears().map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            ) : (
              // Desktop: Use input with datalist (allows typing)
              <>
                <input
                  type="text"
                  list="yearList"
                  className="form-control"
                  value={year}
                  inputMode="numeric"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers
                    if (value === "" || /^\d+$/.test(value)) {
                      setYear(value);
                    }
                  }}
                  placeholder="ปี"
                />
                <datalist id="yearList">
                  {generateYears().map((y) => (
                    <option key={y} value={y} />
                  ))}
                </datalist>
              </>
            )}
          </div>
        </div>

        {/* Display both formats */}
        {displayDate && (
          <small
            className="form-text"
            style={{
              color: displayDate.includes("ไม่ถูกต้อง") ? "#dc3545" : "#28a745",
            }}
          >
            {displayDate}
          </small>
        )}

        {/* Hidden input to store the ISO date */}
        <input
          type="hidden"
          ref={(el) => {
            internalRef.current = el;
            if (refvalue) refvalue(el);
          }}
        />
      </div>
    </div>
  );
};

function containsNumbers(str) {
  return /\d/.test(str);
}

const getLatestHN = async (nodeIndex) => {
  console.log("getLatestHN called with nodeIndex:", nodeIndex);
  const patientsRef = collection(db, "patients");

  // Ensure nodeIndex is 2 digits (01-13)
  const formattedNodeIndex = String(nodeIndex).padStart(2, "0");
  if (!/^(0[1-9]|1[0-9])$/.test(formattedNodeIndex)) {
    throw new Error("nodeIndex must be between 01 and 13");
  }

  // Get Thai year (last 2 digits)
  const thaiYear = (new Date().getFullYear() + 543).toString().slice(2);
  const prefix = `HN-${thaiYear}${formattedNodeIndex}`;

  // Query for the highest existing HN with this prefix
  const q = query(
    patientsRef,
    where("hn", ">=", prefix),
    where("hn", "<", prefix + "9999"),
    orderBy("hn", "desc"),
    limit(1)
  );

  const snapshot = await getDocs(q);
  let nextNumber = 1; // Default to 0001 if none exist

  if (!snapshot.empty) {
    const latestHN = snapshot.docs[0].data().hn;

    // Extract last 4 digits and increment
    const last4Digits = latestHN.slice(-4);
    nextNumber = parseInt(last4Digits, 10) + 1;

    // Ensure we don't exceed 9999
    if (nextNumber > 9999) {
      throw new Error("Maximum HN numbers reached for this prefix");
    }
  }

  // Format with leading zeros
  return `${prefix}${String(nextNumber).padStart(4, "0")}`;
};

const PatientTable = ({ text, sortBy }) => {
  const { currentUser } = useAuth();
  const [patientsList, setPatients] = useState([]);
  const [latestDoc, setLatestDoc] = useState();
  const [firstDoc, setFirstDoc] = useState();
  const [loading, setLoading] = useState(false);
  const [goNext, setGoNext] = useState(false);
  const [goPrev, setGoPrev] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [patientsCount, setPatientsCount] = useState();
  const deleteUserByEmail = httpsCallable(functions, "deleteUserByEmail");
  const manageUser = httpsCallable(functions, "manageUser");
  const deleteAllowed = ["super_admin", "admin"];
  const [nodeName, setNodeName] = useState([]);
  const itemsPerPage = 33;
  const staffAccessContextRef = useRef({ adminData: null, nodes: [] });
  const restrictedPatientsRef = useRef([]);

  const hasRestrictedStaffAccess = () =>
    isStaffCustomerScopedUser(currentUser) &&
    hasExplicitStaffCustomerAccess(staffAccessContextRef.current.adminData);

  const setRestrictedPatientPage = (nextPageNumber) => {
    const allPatients = restrictedPatientsRef.current;
    const nextTotalPages = Math.ceil(allPatients.length / itemsPerPage);
    const safePage = Math.max(
      1,
      Math.min(nextPageNumber, Math.max(nextTotalPages, 1)),
    );
    const startIndex = (safePage - 1) * itemsPerPage;

    setPatients(allPatients.slice(startIndex, startIndex + itemsPerPage));
    setPatientsCount(allPatients.length);
    setTotalPages(nextTotalPages);
    setPage(safePage);
    setGoPrev(safePage > 1);
    setGoNext(safePage < nextTotalPages);
  };

  const deletePatient = async (email, hn) => {
    console.log(email, hn);
    if (email != "") {
      deleteUserByEmail({ email, hn })
        .then(() => {
          notifyTopRight("Delete Success!");
        })
        .catch((error) => {
          notifyError("Detele Error ", error);
        });
    } else {
      const ref = doc(db, "patients", hn);

      await deleteDoc(ref)
        .then(() => {
          notifyTopRight("Delete Success!");
        })
        .catch((error) => {
          notifyError("Detele Error ", error);
        });
    }
  };

  const accoutSetting = (email, hn, isActive) => {
    manageUser({ email, isActive })
      .then(async () => {
        const ref = doc(db, "patients", hn);
        await updateDoc(ref, { loginAccount: !isActive });

        notifyTopRight("Update Success!");
      })
      .catch((error) => {
        notifyError("Update Error ", error);
      });
  };

  let queryHandler = query(
    collection(db, "patients"),
    orderBy(sortBy),
    limit(itemsPerPage)
  );

  const nextPage = async () => {
    setLoading(true);
    if (hasRestrictedStaffAccess()) {
      setRestrictedPatientPage(page + 1);
      setLoading(false);
      return;
    }
    const totalPages = Math.floor(patientsCount / itemsPerPage);
    if (
      currentUser.roles[0] == "super_admin" ||
      currentUser.roles[0] == "sale" ||
      currentUser.roles[0] == "accountant"
    ) {
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        startAt(text),
        endAt(text + "\uf8ff"),
        startAfter(latestDoc),
        limit(itemsPerPage)
      );
    } else {
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        where("nodeRef", "in", nodeName),
        startAt(text),
        endAt(text + "\uf8ff"),
        startAfter(latestDoc),
        limit(itemsPerPage)
      );
    }
    const docSnap = await getDocs(queryHandler);
    const tempPatient = [];
    docSnap.forEach((doc) => {
      tempPatient.push({ ...doc.data() });
    });

    setLoading(false);
    setPage(page + 1);
    setPatients(tempPatient);
    setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
    setFirstDoc(docSnap.docs[0]);
    setGoPrev(true);
    if (page >= totalPages - 1) {
      setGoNext(false);
    }
  };

  const previousPage = async () => {
    setLoading(true);
    if (hasRestrictedStaffAccess()) {
      setRestrictedPatientPage(page - 1);
      setLoading(false);
      return;
    }
    // console.log("count: ", patientsCount);
    // console.log("page: ", page);
    if (
      currentUser.roles[0] == "super_admin" ||
      currentUser.roles[0] == "sale" ||
      currentUser.roles[0] == "accountant"
    ) {
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        startAt(text),
        endAt(text + "\uf8ff"),
        endBefore(firstDoc),
        limitToLast(itemsPerPage)
      );
    } else {
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        where("nodeRef", "in", nodeName),
        startAt(text),
        endAt(text + "\uf8ff"),
        endBefore(firstDoc),
        limitToLast(itemsPerPage)
      );
    }
    const docSnap = await getDocs(queryHandler);
    const tempPatient = [];
    docSnap.forEach((doc) => {
      tempPatient.push({ ...doc.data() });
    });
    if (page <= 2) {
      setGoPrev(false);
    }
    setLoading(false);
    setPage(page - 1);
    setPatients(tempPatient);
    setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
    setFirstDoc(docSnap.docs[0]);
    setGoNext(true);
  };

  useEffect(async () => {
    setLoading(true);
    var count;
    if (
      currentUser.roles[0] == "super_admin" ||
      currentUser.roles[0] == "sale" ||
      currentUser.roles[0] == "accountant"
    ) {
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        startAt(text),
        endAt(text + "\uf8ff"),
        limit(itemsPerPage)
      );
      count = await getCountFromServer(
        query(
          collection(db, "patients"),
          orderBy(sortBy),
          startAt(text),
          endAt(text + "\uf8ff")
        )
      );
    } else {
      const currentAdmin = await getDoc(
        doc(db, "admins", currentUser.displayName)
      );
      const nodes = await getDocs(collection(db, "nodes"));
      const currentAdminData = currentAdmin.exists()
        ? currentAdmin.data()
        : {};
      let nodeCode = currentAdminData.node || [];

      // Ensure `nodeCode` is always an array
      if (!Array.isArray(nodeCode)) {
        nodeCode = nodeCode ? [nodeCode] : []; // Convert string to array or set empty array if null/undefined
      }

      // Find matching node names for all node codes
      const allowedNodeDocs = nodes.docs
        .map((nodeDoc) => ({ id: nodeDoc.id, ...nodeDoc.data() }))
        .filter((nodeData) => nodeCode.includes(nodeData.nodecode));
      const nodeNames = allowedNodeDocs.map((nodeData) => nodeData.nodename);
      staffAccessContextRef.current = {
        adminData: currentAdminData,
        nodes: allowedNodeDocs,
      };

      // console.log(nodeNames);
      setNodeName(nodeNames); // Join if multiple node names

      if (nodeNames.length === 0) {
        restrictedPatientsRef.current = [];
        setPatients([]);
        setPatientsCount(0);
        setTotalPages(0);
        setPage(1);
        setGoNext(false);
        setGoPrev(false);
        setLatestDoc(undefined);
        setFirstDoc(undefined);
        setLoading(false);
        return;
      }

      if (hasRestrictedStaffAccess()) {
        const restrictedQuery = query(
          collection(db, "patients"),
          orderBy(sortBy),
          where("nodeRef", "in", nodeNames),
          startAt(text),
          endAt(text + "\uf8ff")
        );
        const restrictedSnapshot = await getDocs(restrictedQuery);
        restrictedPatientsRef.current = filterRecordsByStaffCustomerAccess({
          records: restrictedSnapshot.docs.map((patientDoc) => ({
            ...patientDoc.data(),
          })),
          currentUser,
          adminData: currentAdminData,
          nodes: allowedNodeDocs,
          getNodeValue: (patient) => patient.nodeRef,
          getCustomerValue: (patient) => patient.refCustomer,
        });
        setRestrictedPatientPage(1);
        setLatestDoc(undefined);
        setFirstDoc(undefined);
        setLoading(false);
        return;
      }

      // Adjust queryHandler and count to filter using multiple node names
      queryHandler = query(
        collection(db, "patients"),
        orderBy(sortBy),
        where("nodeRef", "in", nodeNames), // Use `in` for multiple values
        startAt(text),
        endAt(text + "\uf8ff"),
        limit(itemsPerPage)
      );

      count = await getCountFromServer(
        query(
          collection(db, "patients"),
          orderBy(sortBy),
          where("nodeRef", "in", nodeNames), // Use `in` to handle multiple node names
          startAt(text),
          endAt(text + "\uf8ff")
        )
      );
    }

    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No document");
    }
    const tempPatient = [];
    docSnap.forEach((doc) => {
      tempPatient.push({ ...doc.data() });
    });

    setPatients(tempPatient);
    setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
    setFirstDoc(docSnap.docs[0]);
    setPatientsCount(count.data().count);
    const totalPagesTmp = Math.ceil(count.data().count / itemsPerPage);
    setTotalPages(totalPagesTmp);
    setGoNext(true);
    setGoPrev(false);
    setLoading(false);
    setPage(1);
    if (count.data().count <= itemsPerPage) {
      setGoNext(false);
      setGoPrev(false);
    }
  }, [text, sortBy]);

  const drop = (email, hn) => {
    return (
      <Dropdown>
        <Dropdown.Toggle variant="" className="table-dropdown icon-false">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect x="0" y="0" width="24" height="24"></rect>
              <circle fill="#000000" cx="5" cy="12" r="2"></circle>
              <circle fill="#000000" cx="12" cy="12" r="2"></circle>
              <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            href="#"
            onClick={() => {
              accoutSetting(email, hn, false);
            }}
          >
            Active
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              accoutSetting(email, hn, true);
            }}
          >
            Inactive
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            className="text-danger"
            // onClick={() => {
            //   deletePatient(email, hn);
            // }}
            onClick={() => {
              swal({
                title: `Are you sure to delete patient with ${hn}?`,
                text: "Once deleted, you will not be able to recover this patient !",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((willDelete) => {
                if (willDelete) {
                  deletePatient(email, hn);
                }
              });
            }}
          >
            Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const chackbox = document.querySelectorAll(".customer_shop_single input");
  const motherChackBox = document.querySelector(".customer_shop input");
  // console.log(document.querySelectorAll(".publish_review input")[0].checked);
  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  const chack = (i) => (
    <div className={`custom-control custom-checkbox ml-2`}>
      <input
        type="checkbox"
        className="custom-control-input "
        id={`checkAll${i}`}
        required=""
        onClick={() => chackboxFun()}
      />
      <label className="custom-control-label" htmlFor={`checkAll${i}`}></label>
    </div>
  );

  return (
    <Fragment>
      <Toast />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive-sm">
                <div className="d-flex justify-content-center mt-3"></div>
                <table className="table mb-1 table-striped">
                  <thead>
                    <tr>
                      <th>
                        <h5 className="text-primary"> </h5>
                      </th>
                      <th className="col-2">
                        <h5 className="text-primary">HN</h5>
                      </th>
                      <th className="col-3">
                        <h5 className="text-primary">ชื่อ นามสกุล</h5>
                      </th>
                      <th className="col-1">
                        <h5 className="text-primary">เพศ</h5>
                      </th>
                      <th className="col-2 text-center">
                        <h5 className="text-primary">วันเดือนปีเกิด</h5>
                      </th>
                      <th className="col-2 text-center">
                        <h5 className="text-primary">เบอร์โทรศัพท์</h5>
                      </th>
                      <th className="col-3">
                        <h5 className="text-primary">ที่อยู่</h5>
                      </th>
                    </tr>
                  </thead>
                  {!loading ? (
                    <tbody id="customers">
                      {patientsList.map((patientElement, index) => {
                        return (
                          <tr className="btn-reveal-trigger">
                            <td className="py-1">
                              {index + 1 + itemsPerPage * (page - 1)}
                            </td>
                            <td className="py-1">{patientElement["hn"]}</td>
                            <td className="py-1">
                              <Link
                                // target="_blank"
                                to={"/patient-page/" + patientElement["hn"]}
                              >
                                <div className="media d-flex align-items-center">
                                  {patientElement["firstnameTh"]}{" "}
                                  {patientElement["lastnameTh"]}
                                </div>
                              </Link>
                            </td>
                            <td className="py-1">{patientElement["gender"]}</td>
                            <td className="py-1 text-center">
                              {patientElement["dateOfBirth"]}
                            </td>
                            <td className="py-1 text-center">
                              {patientElement["mobile"]}
                            </td>
                            <td className="py-1">
                              <span
                                className="d-inline-block text-truncate "
                                style={{ maxWidth: "350px" }}
                                data-toggle="address"
                                data-placement="top"
                                title={
                                  patientElement["address1"] +
                                  patientElement["address2"] +
                                  patientElement["province"]
                                }
                              >
                                {patientElement["address1"] +
                                  patientElement["address2"] +
                                  patientElement["province"]}
                              </span>
                            </td>
                            {deleteAllowed.some((allowed) =>
                              currentUser.roles.includes(allowed)
                            ) && (
                              <td className="py-2 text-right">
                                {drop(
                                  patientElement["email"],
                                  patientElement["hn"]
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <div class="media d-flex align-items-center">
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden"></span>
                      </div>
                    </div>
                  )}
                </table>

                <div className="d-flex justify-content-center mt-3">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Button
                      onClick={previousPage}
                      disabled={!goPrev}
                      className="page-link"
                    >
                      <i className="la la-angle-left" />
                    </Button>
                    {/* {Page }{totalPages} */}
                    <div className="d-flex justify-content-center mr-5 ml-5 mt-2">
                      {page}
                      {" / "}
                      {totalPages}
                    </div>

                    <Button
                      onClick={nextPage}
                      disabled={!goNext}
                      className="page-link"
                    >
                      <i className="la la-angle-right" />
                    </Button>
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PatientTextInputForm;

export {
  PatientTextInputForm,
  PatientTextInputNotRequiredForm,
  PatientDropDownForm,
  PatientTable,
  PatientDropDownFormRequired,
  PatientDateOfBirthDropdown,
  getLatestHN,
};
